import { requests, mainApiRoot } from './index'

export const Message = {
  send: payload => requests.post(mainApiRoot, '/contact', payload)
}
